export const FB_PIXEL_EVENT_TYPE_PURCHASE = 'purchase';
export const FB_PIXEL_EVENT_COMPLETE_REGISTRATION = 'CompleteRegistration';
export const FB_PIXEL_EVENT_LEAD = 'Lead';
export const FB_PIXEL_EVENT_TRIAL_START = 'StartTrial';
